module.exports = __webpack_public_path__ + "static/media/intervencion4.62d3a7b9.webp";